import { create } from 'zustand';
import { calculateCondition, createViewModel } from '../services/ConditionService';
import useStageStore from './useStageStore';
import useProductStore from './useProductStore';

const usePropertiesStore = create((set, get) => ({
  selectedGroup: null,
  propertiesRefreshTrigger: 0,
  _saveHistory: null,

  setSelectedGroup: (group) => set({ selectedGroup: group }),

  refreshProperties: () =>
    set((state) => ({
      propertiesRefreshTrigger: state.propertiesRefreshTrigger + 1,
    })),

  /** Call once from GraphicEditorApp after useDesignHistory is ready */
  initCallbacks: ({ saveHistory }) => set({ _saveHistory: saveHistory }),

  propertyChanged: () => {
    const { _saveHistory, refreshProperties } = get();
    const stage = useStageStore.getState().stage;
    if (_saveHistory) _saveHistory(stage);
    refreshProperties();
  },

  checkCondition: (element) => {
    if (!element) return;
    const product = useProductStore.getState().product;
    const condition = element.getAttr('condition');

    const setVisibility = (el, value) => {
      el.setVisible(value);
      el.setAttr('invisible', !value);
    };

    const isEmptyDynamic = (el) => {
      if (!el || !product) return false;
      const textElements = el.find('Text');
      const isDynamicField = textElements.length && textElements[0].getAttr('dynamicField');
      if (isDynamicField) {
        const textValue = product[textElements[0].getAttr('dynamicField')] || textElements[0].getAttr('placeholder');
        return !textValue;
      }
      return false;
    };

    if (condition) {
      if (isEmptyDynamic(element)) {
        setVisibility(element, false);
      } else {
        const conditionComplete = calculateCondition(createViewModel(condition), product);
        setVisibility(element, conditionComplete);
      }
      if (element.parent?.hasName('distributed')) {
        const useAttachedElementsStore = require('./useAttachedElementsStore').default;
        useAttachedElementsStore.getState().reDistributeGroup(element.parent);
      }
    } else {
      setVisibility(element, true);
    }
  },

  reset: () =>
    set({
      selectedGroup: null,
      propertiesRefreshTrigger: 0,
      _saveHistory: null,
    }),
}));

export default usePropertiesStore;
